import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-push",
  "use": "icon-push-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-push\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M6,12.56H9.7V11.44H6V6.28A.28.28,0,0,1,6.15,6a.37.37,0,0,1,.31,0l11.38,5.72a.28.28,0,0,1,0,.5L6.46,18a.37.37,0,0,1-.31,0A.28.28,0,0,1,6,17.72Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol